export default __webpack_public_path__ + "static/media/fond_invitation.58df76e8.png";